<template>
  <div
    v-if="offers.allOffers.length"
    class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16 loyalty-tab__list"
  >
    <offer-allocation-card
      v-for="offer in offers.allOffers"
      :key="offer.offerAllocationPublicId"
      :offer="offer"
      :is-offer-disabled="isOfferDisabled"
    />
  </div>

  <empty-state-tagline
    v-else
    :banner-content="bannerContent"
  />
</template>


<script>
  import { mapGetters } from 'vuex';

  import OfferAllocationCard from './offer-allocation-card/index.vue';

  import EmptyStateTagline from '../empty-state-tagline/index.vue';


  export default {
    name: 'LoyaltyAllocations',

    components: {
      OfferAllocationCard,
      EmptyStateTagline
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('offers', ['offers']),
      ...mapGetters('merchant', ['loyaltyOptions']),

      isOfferDisabled() {
        return this.loyaltyOptions.isStoreSpecificLoyalty;
      },

      bannerContent() {
        return {
          title: this.content.Loyalty.metadata.rewardsEmptyStateTagline,
          message: this.content.Loyalty.metadata.rewardsEmptyStateMessage
        };
      }

    }
  };
</script>


<style lang="sass" scoped>
.loyalty-tab__list
  max-height: 60vh
  overflow-y: auto

  > :deep(*)
    flex-shrink: 0
</style>
